// Case Timer For Law Firms API Document
// ref: https://confluence.zhihuiya.com/display/AWG/Case+Timer+For+Law+Firms+API+Document

import { ICommonBeginEndDate } from './types'

export enum E_CurrentStatus {
    NONE = 'NONE',
    WORKING = 'WORKING',
    PAUSE = 'PAUSE',
    DONE = 'DONE',
}

export enum E_CaseTimeAction {
    START = 'START',
    RESTART = 'RESTART',
    PAUSE = 'PAUSE',
    END = 'END',
    FORBIDDEN = 'FORBIDDEN',
}

export enum E_CaseTimeStatus {
    WORKING = 'WORKING',
    DONE = 'DONE',
}

export interface ICompanyCaseBaseItem {
    id: string
    company_id: string
    title: string
    description: string
    created_at: string
    created_by: string
    updated_by: string
}

export type IGetAllCompanyCaseBaseData = ICompanyCaseBaseItem[]

export interface IUserCaseItem extends ICommonBeginEndDate {
    action: E_CaseTimeAction
    case_id: string
    company_id: string
    description: string
    x_duration: number // 其实叫 duration ，加x 是为了方便报错不要用
    display_case_duration: number
    email: string
    post_action: string
    status: E_CaseTimeStatus
    title: string
    user_case_id: string
    user_id: string
}

export type IGetUserCaseViewData = IUserCaseItem

export type IGetCurrentUserCaseViewData = IUserCaseItem

export type IPutCaseOperationParams = Partial<{
    action: E_CaseTimeAction
    case_id: string
    description: string
    title: string
    user_case_id: string
}>

export type IPutCaseOperationData = IUserCaseItem


export type ICaseTimeForm = {
     title: string,
    description: string
}

export enum E_Buttons {
    Start = 'Start',
    Restart = 'Restart',
    Pause = 'Pause',
    End = 'End',
}
